import LTR from "@brand-icons/ploom/device-laptop/device-laptop-ltr.svg";

import { iconFactory } from "../iconFactory";

export const DeviceLaptopIcon = iconFactory("DeviceLaptopIcon", LTR);
